module.exports = __webpack_public_path__ + "img/absorbente2.bed4b1c6.jpg";